import { apiRequestFirst } from "./client";

const jsonPost = (body) => ({
  method: "POST",
  body,
});

export const authApi = {
  register(payload) {
    return apiRequestFirst(["/auth/register", "/register"], jsonPost(payload));
  },

  login(payload) {
    return apiRequestFirst(["/auth/login", "/login"], jsonPost(payload));
  },

  me() {
    return apiRequestFirst(["/auth/me", "/auth/verify", "/verify", "/me"]);
  },

  verify() {
    return apiRequestFirst(["/auth/verify", "/verify", "/auth/me", "/me"]);
  },

  confirmEmail(payload) {
    return apiRequestFirst(
      ["/auth/confirm-email", "/confirm-email"],
      jsonPost(payload),
    );
  },

  resendConfirmation(payload) {
    return apiRequestFirst(
      ["/auth/resend-confirmation", "/resend-confirmation"],
      jsonPost(payload),
    );
  },

  logout() {
    return apiRequestFirst(["/auth/logout", "/logout"], {
      method: "POST",
    });
  },
};
